import AppBar from '@material-ui/core/AppBar'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import { useTheme } from '@material-ui/core/styles'
import { Redirect, useLocation } from 'react-router-dom'

import { buildFeatureSet, canAccessTab, getCredentials } from '../../cache/auth'
import { TabPanel } from '../../helpers/TabPanel'
import { getTranslate } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import walletPagesRoleManagement from '../../staticRoleManagement/walletRoleManagement'
import WalletList from '../WalletList'
import PaymentTermList from '../WalletPaymentTermList'
import WalletInvoiceList from '../WalletProformaAdminList'
import useStyles from './styles/index.styles'

export default function WalletTabs() {
  const classes = useStyles()
  const theme = useTheme()

  const { pathname } = useLocation()

  const page = pathname.slice(pathname.lastIndexOf('/') + 1)

  const tabsList = [
    {
      label: getTranslate('Wallet List'),

      value: 'wallets',
      link: `/adopay/wallets`,
      component: <WalletList />
    },
    {
      label: getTranslate('Payment Term List'),
      value: 'payment-terms',
      link: `/adopay/payment-terms`,
      component: <PaymentTermList />
    },
    {
      label: getTranslate('Invoice List'),
      value: 'invoice-list',
      link: `/adopay/invoice-list`,
      component: <WalletInvoiceList />
    }
  ]

  const credentials = getCredentials()
  const featureSet = buildFeatureSet(credentials)

  const routeConfig = walletPagesRoleManagement.find(
    (item) => item.route === '/adopay/:page'
  )

  const visibleTabs = tabsList.filter((tab) =>
    canAccessTab(routeConfig, tab.value, featureSet)
  )

  if (!canAccessTab(routeConfig, page, featureSet)) {
    return <Redirect to="/403" />
  }

  return (
    <div className={classes.root}>
      <AppBar position="static" color="transparent">
        <Tabs
          value={page}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          className={classes.tabs}>
          {visibleTabs.map((tabItem) => (
            <Tab
              key={tabItem.value}
              value={tabItem.value}
              className={classes.tab}
              label={tabItem.label}
              component={LocalizedLink}
              to={tabItem.link}
            />
          ))}
        </Tabs>
      </AppBar>
      {visibleTabs.map((tabItem) => (
        <TabPanel
          key={tabItem.value}
          value={page}
          index={tabItem.value}
          dir={theme.direction}
          className={classes.tabPanel}>
          {tabItem.component}
        </TabPanel>
      ))}
    </div>
  )
}
